import styled from "styled-components";

export const Message = styled.div`
  background-color: ${({ variant, ...props }) =>
    variant === "error"
      ? props.theme.colors.colorbgerror
      : props.theme.colors.colorbgsuccess};
  /* border: 0.1px solid black; */
  border-radius: 100px;
  text-align: center;
  padding: 0.4rem;
  margin: 10px 0;
  font-size: 18px;
  font-weight: 100;
  /* width: fit-content; */
  color: ${({ variant, ...props }) =>
    variant === "error"
      ? props.theme.colors.colortxt
      : props.theme.colors.colortxt};
`;

export const Text = styled.div`
  font-size: 44px;
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin-top: auto; */
  /* margin-bottom: auto; */
  /* text-align: center; */

  color: ${({ variant, ...props }) =>
    variant === "error"
      ? props.theme.colors.color200
      : props.theme.colors.color00};
  /* display: inline-block; */
  /* align-items: center; */
  /* padding: 0 100px; */
  /* margin: 10px 0; */
`;
